import { closeAllContextMenus } from ".";
import { OpenMenuResultAction } from "..";
import { AppContextMenuModel } from "models/view/contextMenu/AppContextMenuModel";

export function onNavigated(appMenus: AppContextMenuModel): AppContextMenuModel {
    return appMenus.closeOnNavigation ? closeAllContextMenus(appMenus, { action: OpenMenuResultAction.Cancel }) : appMenus;
}
